import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '@usucampeao/utils-frontend';
import { InputModule } from '../input/input.module';
import { SelectModule } from '../select/select.module';
import { ImovelInfosAdicionaisFormComponent } from './imovel-infos-adicionais-form.component';

@NgModule({
  declarations: [
    ImovelInfosAdicionaisFormComponent
  ],
  imports: [
    // root
    CommonModule,
    IonicModule,
    ReactiveFormsModule,

    // components
    InputModule,
    SelectModule,

    // others
    PipesModule,
  ],
  exports: [
    ImovelInfosAdicionaisFormComponent
  ]
})
export class ImovelInfosAdicionaisFormModule { }
